// extracted by mini-css-extract-plugin
export default {"pageContainer":"styles_pageContainer__uhmU2","mainContentContainer":"styles_mainContentContainer__QtNjJ","signUpContainer":"styles_signUpContainer__9AJxS"};